var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.info.authorize ? "" : "停用") + "授权店铺"),
      ]),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c("el-form-item", { attrs: { label: "店铺" } }, [
            _vm._v(_vm._s(_vm.info.onlineName)),
          ]),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c("el-form-item", { attrs: { label: "渠道" } }, [
            _vm._v(_vm._s(_vm.info.channelWarehouseName)),
          ]),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "平台账号", prop: "name" } },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Appkey", prop: "Appkey" } },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.Appkey,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "Appkey", $$v)
                  },
                  expression: "form.Appkey",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Appsecret", prop: "Appsecret" } },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.Appsecret,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "Appsecret", $$v)
                  },
                  expression: "form.Appsecret",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "SessionKey", prop: "SessionKey" } },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.SessionKey,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "SessionKey", $$v)
                  },
                  expression: "form.SessionKey",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }